import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { t, number } from '~/helpers';
import { handleExportGeneric } from '~/helpers/exportReports';
import {
  deleteMedidor,
  findMedidor,
  recordFiltering,
} from '~/store/modules/medidor/actions';

import Form from './form';

function MedidorList() {
  const redux = useSelector((state) => state.medidor);

  const header = useMemo(
    () => [
      {
        id: 'descricaomedidor',
        label: t('s.configuracao.medidor.descricaomedidor'),
        filter: { type: 'text' },
      },
      {
        id: 'multiplicadormedidor',
        label: t('s.configuracao.medidor.multiplicadormedidor'),
        align: 'right',
        formatted: (value) => number(value),
        filter: { type: 'text' },
      },
      {
        id: 'divisormedidor',
        label: t('s.configuracao.medidor.divisormedidor'),
        align: 'right',
        formatted: (value) => number(value),
        filter: { type: 'text' },
      },
      {
        id: 'casadecimallitromedidor',
        label: t('s.configuracao.medidor.casadecimallitromedidor'),
        align: 'right',
        filter: { type: 'text' },
      },
    ],
    []
  );

  const fieldlist = [
    'descricaomedidor',
    'multiplicadormedidor',
    'divisormedidor',
    'casadecimallitromedidor',
  ];

  const substituirHeader = {
    descricaomedidor: t('s.configuracao.medidor.descricaomedidor'),
    multiplicadormedidor: t('s.configuracao.medidor.multiplicadormedidor'),
    divisormedidor: t('s.configuracao.medidor.divisormedidor'),
    casadecimallitromedidor: t(
      's.configuracao.medidor.casadecimallitromedidor'
    ),
  };

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findMedidor}
      remove={deleteMedidor}
      form={Form}
      keys="idmedidor"
      detach="idcliente"
      excel
      pdf
      onExport={(formato) =>
        handleExportGeneric({
          endpoint: 'medidores',
          formato,
          fields: fieldlist,
          redux,
          headers: substituirHeader,
          title: 'Relatório de Medidores',
          ordination: redux.params.ordination,
          orderfield: redux.params.orderfield,
        })
      }
    />
  );
}

export default MedidorList;
